module.exports = __webpack_public_path__ + "static/GAuth-cafef93d95e64363296652e84b8157b3.png";